module.exports = __webpack_public_path__ + "img/20210213_184257.7152b19a.jpg";